var tri = require("tripartite"); var t = "<div class=\"dist-location\">\n\tdist dist-location\n<\/div>"; 
module.exports = tri.addTemplate("views/search-client/dist-location", t); 